/**
 * Our indexes in Elasticsearch
 */
export var ElasticsearchIndex;
(function (ElasticsearchIndex) {
    ElasticsearchIndex["Order"] = "order";
    ElasticsearchIndex["Recording"] = "recording";
})(ElasticsearchIndex || (ElasticsearchIndex = {}));
export const ALL_INDEXES = Object.keys(ElasticsearchIndex).map(key => ElasticsearchIndex[key]);
const SEPARATOR = '--';
/**
 * @see ElasticsearchIndexAlias
 */
export function mapElasticsearchIndexAliasToIndex(index) {
    const name = index.split(SEPARATOR)[0];
    if (!ALL_INDEXES.includes(name)) {
        throw new Error(`Could not derive Elasticsearch Index name from index: ${name}`);
    }
    return name;
}
/**
 * @see ElasticsearchIndexAlias
 */
export function buildElasticsearchAlias(index, aliasName) {
    return `${index}${SEPARATOR}${aliasName}`;
}
